import { FormControl, IconButton, InputAdornment, TextField } from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import SearchIcon from '@mui/icons-material/Search'
import React, { useState } from 'react'

const SiteSearch = (props) => {

  const [ searchQuery, setSearchQuery ] = useState("");

  return (
    <FormControl>
      <TextField
        aria-label="Search"
        onChange={(e) => { setSearchQuery(e.target.value); }}
        onKeyDown={(e) => e.key === 'Enter' ? window.location.href = window.location.protocol + "//" + window.location.host + "?s=" + searchQuery : null}
        placeholder="Search..."
        sx={{backgroundColor: "#ffffff", borderRadius: "4px", maxWidth: props?.isMobile ? 250 : 300,}}
        variant="outlined"
        value={searchQuery}
        InputProps={{
          endAdornment:
            <InputAdornment position="end">
              <IconButton alt="Search" aria-label="Search" href={window.location.protocol + "//" + window.location.host + "?s=" + searchQuery}>
                <ArrowForwardIcon />
              </IconButton>
            </InputAdornment>,
          startAdornment:
            <InputAdornment position="start">
              <IconButton alt="Search Icon" aria-label="Search Icon" disabled>
                <SearchIcon />
              </IconButton>
            </InputAdornment>,
        }}
      />
    </FormControl>
  )
}

export default SiteSearch